<template>
    <div class="jiaopei">
        <div class="banner">
            <div class="banner-center center">
                <div class="banner-info">
                    <div class="btn shenqing" @click="openDialog('免费试用',0)">申请试用</div>
                </div>
            </div>
        </div>
        <div class="item_1">
            <div class="item-title">
                <h3 class="title1">为教培机构提供一站式数字化解决方案</h3>
                <h4 class="title2">真实使用场景，助力教培机构数字化转型升级</h4>
            </div>
            <div class="item-contents center">
                <ul class="nav-top">
                    <li v-for="(x,index) in item1_list" :class='{"actived": isHover== (index+1)}'  @mouseenter="hovernav(x)">
                        <img :src="'/static/img/product_jiaopei/chanpin1_0'+(index+1)+'.png'" alt="">
                        <div class="title">{{x.title}}</div>
                    </li>
                </ul>
                <div class="item-info clearfix">
                    <div class="item-info-left fl">
                        <img :src="'/static/img/product_jiaopei/chanpin1_chahua_'+itemsHover.ind+'.png'" alt="">
                    </div>
                    <div class="item-info-right fl">
                        <ul>
                            <li class="clearfix" v-for="(y,index_) in itemsHover.infos">
                                <img class="fl" :src="'/static/img/product_jiaopei/icon_0'+itemsHover.ind+'_0'+(index_+1)+'.png'" alt="">
                                <div class="content fl">
                                    <h4>{{y.title1}}</h4>
                                    <p>{{y.info}}</p>
                                </div>
                            </li>
                        </ul>
                    </div>
                </div>
            </div>
        </div>
        <shen-qing></shen-qing>
    </div>
</template>

<script>
import shenQing from "./shenqing.vue";
export default {
    components: {
        shenQing,
    },
    data(){
        return{
            isHover:1,
            itemsHover:{
                    title: "招生营销",
                    ind:1,
                    infos:
                    [
                        {title1:"CRM",info:"层层筛选客户名单，实时掌握潜客跟进状态，有效提高签单率"},
                        {title1:"线上营销",info:"易知独秀海量好玩有趣招生模版一键生成；线上商城展示和销售机构课程"},
                        {title1:"电子优惠券",info:"自定义优惠活动，可手动分发，更支持家长自主传播分享，提高机构营销能力"},
                        {title1:"分享裂变",info:"活动一键分销裂变，更有分销模块，分销成果奖励发放，助力机构营销推广"},
                        {title1:"客户来访接待",info:"快速查看、登记来访客户信息，提高客户接待体验感"},
                    ]
                },
            item1_list: [
                {
                    title: "招生营销",
                    ind:1,
                    infos:
                    [
                        {title1:"CRM",info:"层层筛选客户名单，实时掌握潜客跟进状态，有效提高签单率"},
                        {title1:"线上营销",info:"易知独秀海量好玩有趣招生模版一键生成；线上商城展示和销售机构课程"},
                        {title1:"电子优惠券",info:"自定义优惠活动，可手动分发，更支持家长自主传播分享，提高机构营销能力"},
                        {title1:"分享裂变",info:"活动一键分销裂变，更有分销模块，分销成果奖励发放，助力机构营销推广"},
                        {title1:"客户来访接待",info:"快速查看、登记来访客户信息，提高客户接待体验感"},
                    ]
                },
                {
                    title: "日常课务",
                    ind:2,
                    infos:
                    [
                        {title1:"课堂展示",info:"实时上传课堂风采，家长可查看学员上课情况，提高学员续班率"},
                        {title1:"学员点评",info:"老师和学员可对学员作业进行双向点评，互动提升，保障教学质量"},
                        {title1:"多样化作业",info:"课后作业及打卡作业全面巩固学员学习成果，养成良好学习习惯"},
                        {title1:"学员积分",info:"为学员量身定制积分系统，提高学员积极性"},
                        {title1:"线上课程",info:"老师上传课程，学员在线查看学习并上传作业，在线学习不用愁"},
                    ]
                },
                {
                    title: "教务管理",
                    ind:3,
                    infos:
                    [
                        {title1:"多维度学员管理",info:"多维度管理学员信息，提高机构管理和运营效率"},
                        {title1:"智能排课",info:"可视化视图排课，自定义排课周期，自动检测排课冲突"},
                        {title1:"视图课表",info:"实时视图化查看老师、教室排课情况，提高老师、教室利用率"},
                        {title1:"人脸识别签到",info:"学员到校离校刷脸，可自动完成签到、点名消课、通知家长"},
                    ]
                },
                {
                    title: "老生续费",
                    ind:4,
                    infos:
                    [
                        {title1:"续费预警",info:"自定义设置学员续费预警提醒，大大提高机构续费率"},
                        {title1:"扫码快捷支付",info:"家长在线缴费，支持多种支付方式，费率低至0.3%"},
                        {title1:"订单推送",info:"机构创建订单并推送至家长，家长在线缴费，安全便捷"},
                    ]
                },
                {
                    title: "家校服务",
                    ind:5,
                    infos:
                    [
                        {title1:"多人实时查看",info:"支持多名家庭成员登陆家长端，查看学员在校情况"},
                        {title1:"作业在线提交",info:"支持家长在线提交作业，老师和学员可对作业进行互动点评"},
                        {title1:"课堂动态分享",info:"家长可实时查看学员课堂表现，并可转发学员课堂精彩表现"},
                        {title1:"自主约课",info:"学员可根据自身情况在线预约课程，提高机构课程预约率"},
                    ]
                },
                {
                    title: "机构管理",
                    ind:6,
                    infos:
                    [
                        {title1:"行政管理",info:"老师岗位、考勤、个人信息等清晰明了，学员通知更高效"},
                        {title1:"财务管理",info:"订单、工资、收支明细等数据一手掌控，全面精准掌握机构财务状况"},
                        {title1:"统计分析",info:"多维度统计和分析机构数据，自动生成数据图标，展示更清晰"},
                        {title1:"连锁经营",info:"总部可实时查看汇总各校区数据情况，高效管理直营与监督加盟校区的经营情况"},
                        {title1:"跨校互通",info:"跨校区排课，学员可跨校区上课，信息互通，提高机构运营效率"},
                        {title1:"大数据",info:"各校区数据统筹互联，多品类教育产品运营管理与盈利分析，实现品牌大数据"},
                    ]
                },
            ],
        }
    },
    created(){

    },
    mounted(){

    },
    methods:{
        hovernav(x, ind) {
            this.isHover = x.ind;
            this.itemsHover = {
                title: x.title,
                infos:x.infos,
                ind:x.ind
            };
        },
        openDialog:function(title,type){//type:(0机构,1微官网)
            this.$parent.$refs.openPop.openDialog(title,type);
        }
    }
}
</script>

<style scoped lang="less">
.banner {
        width: 100%;
        height: 480px;
        margin-top: 80px;
        background: url("https://cdntest.yizhiniao.com/newWebsite_/product_jiaopei/chanpin1_banner .png") no-repeat center;

        .banner-center {
            height: 100%;
            position: relative;
        }

        .banner-info {
            position: absolute;
            bottom: 120px;
            left: 60px;
            text-align: left;
            line-height: 47px;
        }
    }
    .item_1{
        padding: 180px 0;
        .title2{
            margin-top: 25px;
            font-size: 22px;
            line-height:30px;

        }
        .item-contents{
            margin-top: 80px;

            ul.nav-top {
                display: flex;
                justify-content: space-between;
                padding: 0 150px;

                >li {
                    width: 100px;
                    /* height: 118px; */

                    img {
                        width: 70px;
                        height: 70pxpx;
                        margin: 0 auto 12px;
                    }

                    .title {
                        text-align: center;
                        color:#4A4A4A;
                        font-size: 20px;
                        line-height: 28px;
                    }


                    &.actived {
                        .title {
                            position:relative;
                            color: #1E1E1E;
                            font-size: 22px;
                            line-height: 30px;
                            padding-bottom: 18px;
                            &:after{
                                content:"";
                                position: absolute;
                                bottom:0;
                                left: 0;
                                width: 100%;
                                height: 4px;
                                background: #1E1E1E;
                                border-radius: 4px;
                            }
                        }
                    }
                }
            }

            .item-info {
                margin-top: 80px;
                .item-info-left{
                    width:670px;
                    height: 340px;
                }
                .item-info-right{
                    width: 460px;
                    margin-left:30px;
                    ul{
                        width: 460px;
                        /* height: 340px; */
                        display: flex;
                        justify-content: space-between;
                        flex-wrap: wrap;
                        li{
                            width: 220px;
                            height: 100px;
                            margin-bottom: 20px;
                            img{
                                width:40px;
                                height:40px;
                            }
                            .content{
                                width: 174px;
                                h4{
                                     font-size: 20px;
                                    font-weight: 500;
                                    color: #4A4A4A;
                                    line-height: 28px;
                                    text-align:left;
                                }
                                 p{
                                    margin-top: 5px;
                                    font-size: 14px;
                                    font-weight: 500;
                                    color: #4A4A4A;
                                    line-height: 20px;
                                    text-align:left;
                                }
                            }
                        }
                    }
                }
            }
        }

    }
</style>



// WEBPACK FOOTER //
// src/components/product_jiaopei.vue